import { bridge } from '../bridge';
import { isWeb } from '../isWeb';

/**
 * 외부 링크를 엽니다.
 * - 앱: ably://outlink 딥링크 사용
 * - 웹: window.open으로 새 탭에서 열기
 */
export const openOutlink = (url: string) => {
  if (isWeb) {
    window.open(url, '_blank');
  } else {
    bridge.openDeeplink(`ably://outlink?url=${url}`);
  }
};
